import { Field, ErrorMessage } from "formik";
import Select from "react-select";
import CatchyCheckbox from "../CatchyCheckbox";
import Infobox from "../Infobox";
import DatePicker from "react-multi-date-picker";
import TimePicker from "react-multi-date-picker/plugins/analog_time_picker";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";
import { persianToEnglishDigitConverter } from "src/utils/persianToEnglishDigitConverter";
import { VscClose } from "react-icons/vsc";

export default function FormikField({
    label,
    placeholder,
    inputName,
    info,
    errors,
    setFieldValue,
    values,
    options,
    disabled = false,
    getOptionLabel = undefined,
    getOptionValue = undefined,
    additionalAction = () => { },
    type = "text",
}) {
    switch (type) {
        case "text":
        case "number":
        case "password":
            return (
                <div className="flex flex-col gap-2 relative">
                    <label className="text-gray-500 dark:text-gray-300" htmlFor={inputName}>{label}</label>
                    <Field
                        className={`p-2 py-3 rounded-xl border border-solid ${errors[inputName] ? "border-red-500" : "border-gray-300"
                            } placeholder-sm:text-sm`}
                        type={type}
                        placeholder={placeholder}
                        name={inputName}
                        disabled={disabled}
                    />
                    {info && (
                        <div className="flex justify-end items-center w-[20px] absolute top-[45px] left-[15px]">
                            <Infobox text={info} />
                        </div>
                    )}
                    <div className="text-red-600 text-sm absolute top-[82px]">
                        <ErrorMessage className="text-red-500" name={inputName} />
                    </div>
                </div>
            );
        case "checkbox":
            return (
                <div
                    className="flex flex-col gap-2"
                    style={{ justifyContent: "flex-end" }}
                >
                    <CatchyCheckbox
                        name={inputName}
                        handleCheck={() => {
                            setFieldValue(inputName, !values[inputName]);
                        }}
                        isActive={values[inputName]}
                        label={label}
                    />
                </div>
            );
        case "file":
            return (
                <div className="flex flex-col gap-2 relative">
                    <label className="text-gray-500 dark:text-gray-300" htmlFor={inputName}>{label}</label>
                    <label
                        htmlFor={inputName}
                        className={`flex items-center justify-between border ${errors[inputName] ? "border-red-500" : "border-gray-300"
                            } border-solid rounded-xl px-2 py-1 text-gray-400`}
                    >
                        <span>{placeholder}</span>
                        <span className="cursor-pointer text-white bg-primary-color px-3 py-2 rounded-xl">
                            انتخاب فایل
                        </span>
                    </label>
                    <input
                        className="hidden p-2 py-3 rounded-xl border border-solid border-gray-300 placeholder-sm:text-sm"
                        type="file"
                        name={inputName}
                        id={inputName}
                        onChange={(event) => {
                            setFieldValue(inputName, event.target.files[0]);
                        }}
                    />
                    <div className="text-red-600 text-sm absolute top-[82px]">
                        <ErrorMessage className="text-red-500" name={inputName} />
                    </div>
                </div>
            );
        case "textarea":
            return (
                <div className="relative flex flex-col gap-2 col-span-2">
                    <label className="flex gap-1 items-center" htmlFor={inputName}>
                        {label}
                        {/* <span className="text-[#7C7C7C] text-sm">(اختیاری)</span> */}
                    </label>
                    <Field
                        className={`p-2 pb-20 rounded-xl border border-solid ${errors[inputName] ? "border-red-500" : "border-gray-300"
                            } w-full xl:placeholder-text-xs`}
                        type="textarea"
                        placeholder={placeholder}
                        name={inputName}
                    />
                    <div className="text-red-600 text-sm absolute top-[82px]">
                        <ErrorMessage className="text-red-500" name={inputName} />
                    </div>
                </div>
            );
        case "datepicker":
            return (
                <div className="flex flex-col gap-1 w-full relative">
                    <label htmlFor={inputName}>{label} </label>
                    <DatePicker
                        style={{ width: "100%", padding: "24px 15px" }}
                        format="YYYY/MM/DD HH:mm"
                        plugins={[<TimePicker hideSeconds />]}
                        // minDate={new Date()}
                        calendar={persian}
                        locale={persian_fa}
                        value={values?.[inputName]}
                        onChange={(value) => {
                            setFieldValue(
                                inputName,
                                persianToEnglishDigitConverter(
                                    value?.format("YYYY/MM/DD HH:mm")
                                )
                            );
                        }}
                        placeholder={placeholder}
                    />
                    {values?.[inputName] && (
                        <div
                            className="absolute left-4 top-[46px] cursor-pointer"
                            onClick={() => {
                                setFieldValue(inputName, null);
                            }}
                        >
                            <VscClose color="gray" />
                        </div>
                    )}
                    <div className="text-error-primary-color text-sm absolute top-[72px]">
                        <ErrorMessage
                            className="text-error-primary-color"
                            name={inputName}
                        />
                    </div>
                </div>
            );
        case "select":
            return (
                <div className="flex flex-col gap-2 relative">
                    <label className="text-gray-500 dark:text-gray-300" htmlFor={inputName}>{label}</label>
                    <Select
                        name={inputName}
                        value={values[inputName]
                            ? options.map((item) => {
                                if (values[inputName] === item.value) {
                                    return item;
                                }
                            })
                            : null} className="al-dashboard"
                        // isMulti
                        isDisabled={disabled}
                        isClearable
                        placeholder={placeholder}
                        options={options}
                        components={{
                            IndicatorSeparator: () => info ? <div className="relative"><Infobox text={info} /></div> : null,
                        }}
                        onChange={(selectedOption) => {
                            additionalAction(selectedOption)
                            setFieldValue(
                                inputName,
                                selectedOption ? selectedOption.value : null
                            );
                        }}
                    />
                </div>
            );
        case "multiselect":
            return (
                <div className="flex flex-col gap-2">
                    <label className="text-gray-500 dark:text-gray-300" htmlFor={inputName}>{label}</label>
                    <Select
                        name={inputName}
                        value={values.inputName}
                        className="al-dashboard"
                        isMulti
                        isClearable
                        isDisabled={disabled}
                        placeholder={placeholder}
                        options={options}
                        components={{
                            IndicatorSeparator: () => <Infobox text={info} />,
                        }}
                        onChange={(selectedOption) => {
                            additionalAction(selectedOption)
                            setFieldValue(
                                inputName,
                                selectedOption.map(function (single) {
                                    return single.value;
                                })
                            );
                        }}
                    />
                </div>
            );
        default:
            break;
    }
}
